﻿import React, { useState } from 'react';
import styles from './ErrorPage.module.scss';
import animationData from 'assets/animations/error-circle.json';
import { LottieContainer } from 'components/animations/LottieContainer.tsx';
import { Button, ButtonColor } from 'components/uikit/buttons/Button';
import { useNavigate } from 'react-router';
import { Links } from 'application/constants/links';
import { useScopedTranslation } from '../../../application/localization/useScopedTranslation.ts';
import { ActionText } from '../../../components/uikit/ActionText.tsx';
import UserReportModal from '../../authorized/rootPage/components/UserReportModal.tsx';
import { Tooltip } from '../../../components/uikit/Tooltip.tsx';
import pageStyles from '../../authorized/warranty-request/WarrantyRequest.module.scss';

const ErrorPage = () => {
  const navigate = useNavigate();
  const i18n = useScopedTranslation('Page.ErrorPage');
  const [isUserReportModalShown, setIsUserReportModalShown] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <>
      <div className={styles.errorContent}>
        <div className={styles.numbers}>
          <div>4</div>
          <LottieContainer animationData={animationData} />
          <div>4</div>
        </div>
        <h1 className={styles.h1}>{i18n.t('page_is_not_available')}</h1>
        <p className={styles.errorDescription}>{i18n.t('page_not_found')}</p>
      </div>
      <div className={styles.errorFooter}>
        <Button
          className={styles.errorButton}
          color={ButtonColor.Secondary}
          onClick={async () => {
            void navigate(Links.Authorized.Welcome.link());
          }}
          title={i18n.t('go_to_home_page')}
        ></Button>
        <div className={styles.reportContainer}>
          <div>{i18n.t('report_text')}</div>
          <ActionText
            onClickHandler={() => {
              setIsUserReportModalShown(true);
            }}
            text={i18n.t('report_text_button')}
          />
        </div>
      </div>
      {isUserReportModalShown && (
        <UserReportModal
          onClose={() => {
            setIsUserReportModalShown(false);
          }}
          onSubmit={() => {
            setIsUserReportModalShown(false);
            setIsTooltipVisible(true);
            setTimeout(() => {
              setIsTooltipVisible(false);
            }, 2500);
          }}
        />
      )}
      {isTooltipVisible && (
        <Tooltip
          closeTooltip={() => setIsTooltipVisible(false)}
          bodyContent={<div>{i18n.t('tooltip_message')}</div>}
          className={pageStyles.tooltip}
          showCancelButton={true}
        />
      )}
    </>
  );
};

export default ErrorPage;
